import Notification from "./notification";
import Message from "./message";

export async function restore() {
  // Create DataStore with its own IndexedDB Connection
  Notification.createDataStore().then();
  Message.createDataStore().then();

  // Restore All Necessary Data Stores
  Notification.restore();
  Message.restore();
}

export default {
  restore,
  Message,
  Notification
};
